import React from 'react';
import { objectionSection } from '../data/copy';
export function ObjectionSection() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-119" data-mp="1vzafkhey6klv">
      <div className="mx-auto max-w-4xl text-center" data-id="element-120" data-mp="1w13q47soloz5">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-121" data-mp="29zl77mo30383">
          {objectionSection.title}
        </h2>
        <p className="text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-122" data-mp="2jwg646o9o5mw">
          {objectionSection.intro}
        </p>
        <ul className="mx-auto mb-1.5 mt-1 flex max-w-3xl flex-wrap items-center justify-center gap-1" data-id="element-123" data-mp="2ewlcvwh0r3yo">
          {objectionSection.thoughts.map(thought => <li key={thought} className="rounded-md border border-pf-creamDark bg-pf-cream px-2 py-1 text-[12px] font-semibold italic text-pf-ink sm:text-sm" data-id="element-124" data-mp="2onohh895q12p">
              {thought}
            </li>)}
        </ul>

        <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-125" data-mp="2xpxmxjpkj498">
          <p className="font-display text-[14px] font-extrabold uppercase text-pf-coral sm:text-xl" data-id="element-126" data-mp="6fs7fxcfryp4">
            {objectionSection.mid[0]}
          </p>
          <p data-id="element-127" data-mp="be24yelmvbdw">{objectionSection.mid[1]}</p>
          <p className="font-bold text-pf-navy" data-id="element-128" data-mp="bh7qjjv1zv4v">{objectionSection.mid[2]}</p>
        </div>

        <ol className="mx-auto my-1.5 flex max-w-3xl flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[12px] font-bold text-pf-navy sm:text-[15px]" data-id="element-129" data-mp="gblgv7uuzc2o">
          {objectionSection.steps.map(step => <li key={step} className="flex items-center gap-1" data-id="element-130" data-mp="u5cqshci4xyx">
              <span className="h-1.5 w-1.5 rounded-full bg-pf-sage" aria-hidden="true" data-id="element-131" data-mp="u64obxpnt5ru" />
              {step}
            </li>)}
        </ol>

        <p className="mx-auto max-w-3xl text-[12.5px] font-bold leading-snug text-pf-navy sm:text-base" data-id="element-132" data-mp="1442behvs8wiv">
          {objectionSection.close}
        </p>
      </div>
    </section>;
}